import CommonStyles from 'shared/style/commonPageStyles'
import styled from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;

		& > h2 {
			${({theme}) => theme.font.small_bold};

			& > span {
				color: ${({theme}) => theme.color.major};
				${({theme}) => theme.font.small_bold};
			}
		}
	`,

	AreaHeader: styled.div`
			display: flex;
			justify-content: space-between;
			align-items: center;

			& > h2 {
					${({theme}) => theme.font.small_bold};

					& > span {
							color: ${({theme}) => theme.color.major};
							${({theme}) => theme.font.small_bold};
					}
			}
	`,

	TableDiv: styled.div`
			display: flex;
			flex-wrap: wrap;
			border-top: 1px solid ${({ theme }) => theme.color.grey2};
	`,

	VoucherItem: styled.div`
			display: flex;
			border-bottom: 1px solid ${({ theme }) => theme.color.grey2};
			gap: 8px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				flex-direction: column;
				gap: 0;
				padding: 5px 0;
			}
	`,

	VoucherRow: styled.div`
			flex-basis: 50%;
			flex-grow: 1;
			display: flex;
			gap: 6px;
			align-items: center;
	`,

	VoucherRowRight: styled.div`
			flex-basis: 50%;
			flex-grow: 1;
			display: flex;
			gap: 16px;
			align-items: center;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				gap: 4px;
			}
	`,

	VoucherLabel: styled.h2`
			${({theme}) => theme.font.small_bold};
			font-size: 16px;
			min-width: 200px;
			display: flex;
			align-items: center;
			width: 200px;
			background-color: ${({theme}) => theme.color.grey1};
			padding: 13px 20px;
			height: 100%;

			& > span {
					color: ${({theme}) => theme.color.major};
			}

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				font-size: 12px;
				min-width: 100px;
				width: 100px;
				padding: 13px 10px;
			}
	`,

	VoucherInput: styled.div`
			flex: 1;

			& > input {
					${({theme}) => theme.font.small};
					font-size: 16px;
					width: 100%;
					padding: 8px 16px;
					margin: 6px 0;
					border: 1px solid ${({theme}) => theme.color.grey3};
					border-radius: 4px;

					@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
						font-size: 12px;
					}
			}

			& > span {
					font-size: 16px;
					${({theme}) => theme.font.small};
					padding: 8px 12px;
			}
	`,

	VoucherExpiration: styled.div`
			flex: 1;
	`,

	RadioGroup: styled.div`
			display: flex;
			gap: 16px;

			& > button {
					display: flex;
					align-items: center;
					justify-content: center;
					min-width: 24px;
					min-height: 24px;
					border-radius: 4px;
					background-color: #DFDFE7;
					border: none;
					cursor: pointer;
			}

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				gap: 4px;
			}
	`,

	RadioOption: styled.div`
			display: flex;
			align-items: center;
			gap: 4px;

			& > label {
					${({theme}) => theme.font.small};
					cursor: pointer;

					@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
						${({theme}) => theme.font.extra_small};
					}
			}

			& > input[type="radio"] {
					appearance: none;
					-webkit-appearance: none;
					-moz-appearance: none;
					width: 16px;
					height: 16px;
					border: 2px solid #ED3241;
					border-radius: 50%;
					cursor: pointer;
					position: relative;
					background-color: white;
					transition: all 0.2s ease;

					&:checked::after {
					content: '';
					width: 8px;
					height: 8px;
					background-color: #ED3241;
					border-radius: 50%;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);

					@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
						/* display: none; */
					}
				}
			}
	`,

	ImgUploadDiv: styled.div`
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 16px;
	`,
	ImgElement: styled.div`
		width: fit-content;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: end;
		flex-wrap: wrap;
		gap: 6px;

		& > img {
			width: 160px;
			height: 160px;
			object-fit: cover;
			object-position: center center;
			border-radius: 8px;
			cursor: pointer;
		}

		& > button {
			${({theme}) => theme.font.extra_small};
			display: flex;
			align-items: center;
			padding-top: 2px;
		}
	`,
}

export default Style
